import React from 'react'

const Header = () => (
  <div
    className="lps"
    dangerouslySetInnerHTML={{__html: headerString}}
  >
  </div>
)

export default Header

const headerString = `
<div class="header-container">
    <div class="top-switch-bg">
        <div class="row clearfix">
            <div class="grid_6 select-switch">




            </div>
            <div class="grid_6">
                <ul class="links">
	                        <li><a href="https://www.labproservices.com/customer/account/" title="Account">Account</a></li>
			            <li class="separator">&nbsp;</li>
			                                <li><a href="https://www.labproservices.com/wishlist/" title="Wishlist">Wishlist</a></li>
			            <li class="separator">&nbsp;</li>
			                                <li><a href="https://www.labproservices.com/checkout/" title="Checkout" class="top-link-checkout">Checkout</a></li>
			            <li class="separator">&nbsp;</li>
			                                <li><a href="https://www.labproservices.com/customer/account/login/" title="Log In">Log In</a></li>
			                </ul>
            </div>
        </div>
    </div>
    <div class="header-wrapper  search-field" style="height: 186px;">
        <header class="">
                            <div class="row clearfix">
                    <div class="grid_12 ">
                                                <h1 class="logo"><strong>Lab Procurement Services</strong><a href="https://www.labproservices.com/" title="Lab Procurement Services" class="logo"><p><img style="max-width: 300px;" alt="Lab Pro Services" src="https://www.labproservices.com//skin/frontend/default/theme692/images/LPS-Banner-Cropped.png"></p></a></h1>

                        <!-- NAVIGATION -->
                        <!-- navigation BOF -->
<!----><div class="nav-container">
    <div class="nav-top-title"><div class="icon"><span></span><span></span><span></span></div><a href="#">Navigation</a></div>
    <ul id="queldoreiNav">
	            <li class="level0 nav-1 level-top first parent">
<a href="https://www.labproservices.com/supplies.html" class="level-top"><em>+</em>
<span>Supplies</span>
</a>
<div class="sub-wrapper">
<ul class="level0">
<li><ol><li class="level1 nav-1-1 first parent">
<a href="https://www.labproservices.com/supplies/centrifuge-tubes.html"><em>+</em>
<span>Centrifuge Tubes</span>
</a>
<div class="sub-wrapper">
<ul class="level1">
<li class="level2 nav-1-1-1 first">
<a href="https://www.labproservices.com/supplies/centrifuge-tubes/15-and-50-ml-centrifuge-tubes.html">
<span>15 and 50 ML Centrifuge Tubes</span>
</a>
</li><li class="level2 nav-1-1-2">
<a href="https://www.labproservices.com/supplies/centrifuge-tubes/centrifuge-bottles.html">
<span>Centrifuge Bottles</span>
</a>
</li><li class="level2 nav-1-1-3 last">
<a href="https://www.labproservices.com/supplies/centrifuge-tubes/microcentrifuge.html">
<span>Microcentrifuge</span>
</a>
</li>
</ul>
</div>
</li><li class="level1 nav-1-2 parent">
<a href="https://www.labproservices.com/supplies/chemicals.html"><em>+</em>
<span>Chemicals</span>
</a>
<div class="sub-wrapper">
<ul class="level1">
<li class="level2 nav-1-2-4 first">
<a href="https://www.labproservices.com/supplies/chemicals/acids.html">
<span>Acids</span>
</a>
</li><li class="level2 nav-1-2-5">
<a href="https://www.labproservices.com/supplies/chemicals/antibiotics.html">
<span>Antibiotics</span>
</a>
</li><li class="level2 nav-1-2-6">
<a href="https://www.labproservices.com/supplies/chemicals/buffers-solutions.html">
<span>Buffers &amp; Solutions</span>
</a>
</li><li class="level2 nav-1-2-7">
<a href="https://www.labproservices.com/supplies/chemicals/carbohydrates.html">
<span>Carbohydrates</span>
</a>
</li><li class="level2 nav-1-2-8">
<a href="https://www.labproservices.com/supplies/chemicals/general-chemicals.html">
<span>General Chemicals</span>
</a>
</li><li class="level2 nav-1-2-9">
<a href="https://www.labproservices.com/supplies/chemicals/molecular-biology.html">
<span>Molecular Biology</span>
</a>
</li><li class="level2 nav-1-2-10">
<a href="https://www.labproservices.com/supplies/chemicals/organics.html">
<span>Organics</span>
</a>
</li><li class="level2 nav-1-2-11">
<a href="https://www.labproservices.com/supplies/chemicals/ph-buffers.html">
<span>Calibration Standards</span>
</a>
</li><li class="level2 nav-1-2-12">
<a href="https://www.labproservices.com/supplies/chemicals/reagents.html">
<span>Reagents</span>
</a>
</li><li class="level2 nav-1-2-13">
<a href="https://www.labproservices.com/supplies/chemicals/salts.html">
<span>Salts</span>
</a>
</li><li class="level2 nav-1-2-14 last">
<a href="https://www.labproservices.com/supplies/chemicals/solvents.html">
<span>Solvents</span>
</a>
</li>
</ul>
</div>
</li><li class="level1 nav-1-3 parent">
<a href="https://www.labproservices.com/supplies/chrom-vials.html"><em>+</em>
<span>Chromatography</span>
</a>
<div class="sub-wrapper">
<ul class="level1">
<li class="level2 nav-1-3-15 first last">
<a href="https://www.labproservices.com/supplies/chrom-vials/vials.html">
<span>Vials</span>
</a>
</li>
</ul>
</div>
</li><li class="level1 nav-1-4 parent">
<a href="https://www.labproservices.com/supplies/cleaning.html"><em>+</em>
<span>Cleaning</span>
</a>
<div class="sub-wrapper">
<ul class="level1">
<li class="level2 nav-1-4-16 first">
<a href="https://www.labproservices.com/supplies/cleaning/cleanroom.html">
<span>Cleanroom</span>
</a>
</li><li class="level2 nav-1-4-17">
<a href="https://www.labproservices.com/supplies/cleaning/underpads-and-liners.html">
<span>Underpads and Liners</span>
</a>
</li><li class="level2 nav-1-4-18">
<a href="https://www.labproservices.com/supplies/cleaning/wipes.html">
<span>Wipes</span>
</a>
</li><li class="level2 nav-1-4-19 last">
<a href="https://www.labproservices.com/supplies/cleaning/cleanroom-adhesive-mats.html">
<span>Cleanroom Adhesive Mats</span>
</a>
</li>
</ul>
</div>
</li><li class="level1 nav-1-5 parent">
<a href="https://www.labproservices.com/supplies/clinical.html"><em>+</em>
<span>Clinical</span>
</a>
<div class="sub-wrapper">
<ul class="level1">
<li class="level2 nav-1-5-20 first last">
<a href="https://www.labproservices.com/supplies/clinical/urinalysis.html">
<span>Urinalysis</span>
</a>
</li>
</ul>
</div>
</li><li class="level1 nav-1-6 parent">
<a href="https://www.labproservices.com/supplies/containers.html"><em>+</em>
<span>Containers</span>
</a>
<div class="sub-wrapper">
<ul class="level1">
<li class="level2 nav-1-6-21 first">
<a href="https://www.labproservices.com/supplies/containers/bags-autoclave.html">
<span>Bags / Autoclave</span>
</a>
</li><li class="level2 nav-1-6-22">
<a href="https://www.labproservices.com/supplies/containers/beakers.html">
<span>Beakers</span>
</a>
</li><li class="level2 nav-1-6-23">
<a href="https://www.labproservices.com/supplies/containers/bottles-and-jars.html">
<span>Bottles and Jars</span>
</a>
</li><li class="level2 nav-1-6-24">
<a href="https://www.labproservices.com/supplies/containers/caps-and-closures.html">
<span>Caps and Closures</span>
</a>
</li><li class="level2 nav-1-6-25">
<a href="https://www.labproservices.com/supplies/containers/cells-and-cuvettes.html">
<span>Cells and Cuvettes</span>
</a>
</li><li class="level2 nav-1-6-26">
<a href="https://www.labproservices.com/supplies/containers/cryogenic-storage-boxes-racks.html">
<span>Cryogenic Storage Boxes &amp; Racks</span>
</a>
</li><li class="level2 nav-1-6-27">
<a href="https://www.labproservices.com/supplies/containers/cryogenic-vials.html">
<span>Cryogenic Vials</span>
</a>
</li><li class="level2 nav-1-6-28">
<a href="https://www.labproservices.com/supplies/containers/environmental.html">
<span>Environmental</span>
</a>
</li><li class="level2 nav-1-6-29">
<a href="https://www.labproservices.com/supplies/containers/liquid-containers.html">
<span>Liquid Containers</span>
</a>
</li><li class="level2 nav-1-6-30">
<a href="https://www.labproservices.com/supplies/containers/cans-buckets-pails.html">
<span>Cans, Buckets and Pails</span>
</a>
</li><li class="level2 nav-1-6-31">
<a href="https://www.labproservices.com/supplies/containers/plastic-sample-bags.html">
<span>Plastic Sample Bags</span>
</a>
</li><li class="level2 nav-1-6-32 last">
<a href="https://www.labproservices.com/supplies/containers/test-tubes-disposable.html">
<span>Test Tubes, Disposable</span>
</a>
</li>
</ul>
</div>
</li><li class="level1 nav-1-7 parent">
<a href="https://www.labproservices.com/supplies/cryogenics.html"><em>+</em>
<span>Cryogenics</span>
</a>
<div class="sub-wrapper">
<ul class="level1">
<li class="level2 nav-1-7-33 first last">
<a href="https://www.labproservices.com/supplies/cryogenics/racks-boxes-storage.html">
<span>Racks, Boxes, Storage</span>
</a>
</li>
</ul>
</div>
</li><li class="level1 nav-1-8 parent">
<a href="https://www.labproservices.com/supplies/filtration.html"><em>+</em>
<span>Filtration</span>
</a>
<div class="sub-wrapper">
<ul class="level1">
<li class="level2 nav-1-8-34 first">
<a href="https://www.labproservices.com/supplies/filtration/bottle-top-filters.html">
<span>Bottle Top Filters</span>
</a>
</li><li class="level2 nav-1-8-35">
<a href="https://www.labproservices.com/supplies/filtration/capsule-filters.html">
<span>Capsule Filters</span>
</a>
</li><li class="level2 nav-1-8-36">
<a href="https://www.labproservices.com/supplies/filtration/filter-funnels.html">
<span>Filter Funnels</span>
</a>
</li><li class="level2 nav-1-8-37">
<a href="https://www.labproservices.com/supplies/filtration/filter-manifolds.html">
<span>Filter Manifolds</span>
</a>
</li><li class="level2 nav-1-8-38">
<a href="https://www.labproservices.com/supplies/filtration/membrane.html">
<span>Membrane</span>
</a>
</li><li class="level2 nav-1-8-39">
<a href="https://www.labproservices.com/supplies/filtration/nitrocellulose.html">
<span>Nitrocellulose</span>
</a>
</li><li class="level2 nav-1-8-40">
<a href="https://www.labproservices.com/supplies/filtration/syringe.html">
<span>Syringe</span>
</a>
</li><li class="level2 nav-1-8-41 last">
<a href="https://www.labproservices.com/supplies/filtration/syringeless.html">
<span>Syringeless</span>
</a>
</li>
</ul>
</div>
</li><li class="level1 nav-1-9 parent">
<a href="https://www.labproservices.com/supplies/general.html"><em>+</em>
<span>General</span>
</a>
<div class="sub-wrapper">
<ul class="level1">
<li class="level2 nav-1-9-42 first">
<a href="https://www.labproservices.com/supplies/general/clamps.html">
<span>Clamps</span>
</a>
</li><li class="level2 nav-1-9-43">
<a href="https://www.labproservices.com/supplies/general/labeling-products.html">
<span>Labeling Products</span>
</a>
</li><li class="level2 nav-1-9-44">
<a href="https://www.labproservices.com/supplies/general/sieves.html">
<span>Sieves</span>
</a>
</li><li class="level2 nav-1-9-45">
<a href="https://www.labproservices.com/supplies/general/stirring-bars.html">
<span>Stirring Bars</span>
</a>
</li><li class="level2 nav-1-9-46 last">
<a href="https://www.labproservices.com/supplies/general/sampling-supplies.html">
<span>Sampling Supplies</span>
</a>
</li>
</ul>
</div>
</li><li class="level1 nav-1-10 parent">
<a href="https://www.labproservices.com/supplies/glassware.html"><em>+</em>
<span>Glassware</span>
</a>
<div class="sub-wrapper">
<ul class="level1">
<li class="level2 nav-1-10-47 first last">
<a href="https://www.labproservices.com/supplies/glassware/glassware-reusable.html">
<span>Glassware, Reusable</span>
</a>
</li>
</ul>
</div>
</li><li class="level1 nav-1-11 parent">
<a href="https://www.labproservices.com/supplies/life-science.html"><em>+</em>
<span>Life Science</span>
</a>
<div class="sub-wrapper">
<ul class="level1">
<li class="level2 nav-1-11-48 first">
<a href="https://www.labproservices.com/supplies/life-science/blotters.html">
<span>Blotters</span>
</a>
</li><li class="level2 nav-1-11-49 last">
<a href="https://www.labproservices.com/supplies/life-science/cell-culture-media.html">
<span>Cell Culture Media</span>
</a>
</li>
</ul>
</div>
</li><li class="level1 nav-1-12 last parent">
<a href="https://www.labproservices.com/supplies/liquid-handling.html"><em>+</em>
<span>Liquid Handling</span>
</a>
<div class="sub-wrapper">
<ul class="level1">
<li class="level2 nav-1-12-50 first">
<a href="https://www.labproservices.com/supplies/liquid-handling/pipet-tips.html">
<span>Pipet Tips</span>
</a>
</li><li class="level2 nav-1-12-51">
<a href="https://www.labproservices.com/supplies/liquid-handling/serological-pipets.html">
<span>Serological Pipets</span>
</a>
</li><li class="level2 nav-1-12-52">
<a href="https://www.labproservices.com/supplies/liquid-handling/pipet-accessories.html">
<span>Pipetting Accessories</span>
</a>
</li><li class="level2 nav-1-12-53">
<a href="https://www.labproservices.com/supplies/liquid-handling/reservoirs.html">
<span>Reservoirs</span>
</a>
</li><li class="level2 nav-1-12-54 last">
<a href="https://www.labproservices.com/supplies/liquid-handling/transfer-pipets.html">
<span>Transfer Pipets</span>
</a>
</li>
</ul>
</div>
</li></ol></li><li><ol><li class="level1 nav-1-13 parent">
<a href="https://www.labproservices.com/supplies/measurements.html"><em>+</em>
<span>Measurements</span>
</a>
<div class="sub-wrapper">
<ul class="level1">
<li class="level2 nav-1-13-55 first">
<a href="https://www.labproservices.com/supplies/measurements/hydrometers.html">
<span>Hydrometers</span>
</a>
</li><li class="level2 nav-1-13-56">
<a href="https://www.labproservices.com/supplies/measurements/temperature.html">
<span>Temperature</span>
</a>
</li><li class="level2 nav-1-13-57 last">
<a href="https://www.labproservices.com/supplies/measurements/timers-clocks.html">
<span>Timers &amp; Clocks</span>
</a>
</li>
</ul>
</div>
</li><li class="level1 nav-1-14 parent">
<a href="https://www.labproservices.com/supplies/microscopy-accessories.html"><em>+</em>
<span>Microscopy</span>
</a>
<div class="sub-wrapper">
<ul class="level1">
<li class="level2 nav-1-14-58 first">
<a href="https://www.labproservices.com/supplies/microscopy-accessories/accessories.html">
<span>Accessories</span>
</a>
</li><li class="level2 nav-1-14-59">
<a href="https://www.labproservices.com/supplies/microscopy-accessories/coverslips.html">
<span>Coverslips</span>
</a>
</li><li class="level2 nav-1-14-60 last">
<a href="https://www.labproservices.com/supplies/microscopy-accessories/slides.html">
<span>Slides</span>
</a>
</li>
</ul>
</div>
</li><li class="level1 nav-1-15 parent">
<a href="https://www.labproservices.com/supplies/microbiology.html"><em>+</em>
<span>Microbiology</span>
</a>
<div class="sub-wrapper">
<ul class="level1">
<li class="level2 nav-1-15-61 first">
<a href="https://www.labproservices.com/supplies/microbiology/microbial-growth-media.html">
<span>Microbial Growth Media</span>
</a>
</li><li class="level2 nav-1-15-62">
<a href="https://www.labproservices.com/supplies/microbiology/microbiology-supplies.html">
<span>Microbiology Supplies</span>
</a>
</li><li class="level2 nav-1-15-63">
<a href="https://www.labproservices.com/supplies/microbiology/cell-culture-media.html">
<span>Cell Culture Media</span>
</a>
</li><li class="level2 nav-1-15-64">
<a href="https://www.labproservices.com/supplies/microbiology/petri-dishes.html">
<span>Petri Dishes</span>
</a>
</li><li class="level2 nav-1-15-65 last">
<a href="https://www.labproservices.com/supplies/microbiology/prepared-media.html">
<span>Prepared Media</span>
</a>
</li>
</ul>
</div>
</li><li class="level1 nav-1-16 parent">
<a href="https://www.labproservices.com/supplies/plasticware.html"><em>+</em>
<span>Plasticware</span>
</a>
<div class="sub-wrapper">
<ul class="level1">
<li class="level2 nav-1-16-66 first">
<a href="https://www.labproservices.com/supplies/plasticware/microplates.html">
<span>Microplates</span>
</a>
</li><li class="level2 nav-1-16-67">
<a href="https://www.labproservices.com/supplies/plasticware/plastic-labware.html">
<span>Plastic Labware</span>
</a>
</li><li class="level2 nav-1-16-68">
<a href="https://www.labproservices.com/supplies/plasticware/tissue-culture.html">
<span>Tissue Culture</span>
</a>
</li><li class="level2 nav-1-16-69">
<a href="https://www.labproservices.com/supplies/plasticware/pcr-supplies.html">
<span>PCR Supplies</span>
</a>
</li><li class="level2 nav-1-16-70">
<a href="https://www.labproservices.com/supplies/plasticware/spatulas-spoons-scoops.html">
<span>Spatulas/Spoons/Scoops</span>
</a>
</li><li class="level2 nav-1-16-71 last">
<a href="https://www.labproservices.com/supplies/plasticware/weigh-dishes.html">
<span>Weigh Dishes</span>
</a>
</li>
</ul>
</div>
</li><li class="level1 nav-1-17 last parent">
<a href="https://www.labproservices.com/supplies/safety-and-apparel.html"><em>+</em>
<span>PPE/Safety</span>
</a>
<div class="sub-wrapper">
<ul class="level1">
<li class="level2 nav-1-17-72 first">
<a href="https://www.labproservices.com/supplies/safety-and-apparel/apparel.html">
<span>Apparel</span>
</a>
</li><li class="level2 nav-1-17-73">
<a href="https://www.labproservices.com/supplies/safety-and-apparel/gloves-non-sterile.html">
<span>Gloves</span>
</a>
</li><li class="level2 nav-1-17-74">
<a href="https://www.labproservices.com/supplies/safety-and-apparel/ppe.html">
<span>PPE</span>
</a>
</li><li class="level2 nav-1-17-75 last">
<a href="https://www.labproservices.com/supplies/safety-and-apparel/safety-ampoule-openers.html">
<span>Safety Ampoule Openers</span>
</a>
</li>
</ul>
</div>
</li></ol></li>
</ul>
</div>
</li><li class="level0 nav-2 level-top parent">
<a href="https://www.labproservices.com/equipment.html" class="level-top"><em>+</em>
<span>Equipment</span>
</a>
<div class="sub-wrapper">
<ul class="level0">
<li class="last"><ol><li class="level1 nav-2-1 first parent">
<a href="https://www.labproservices.com/equipment/centrifugation.html"><em>+</em>
<span>Centrifugation</span>
</a>
<div class="sub-wrapper">
<ul class="level1">
<li class="level2 nav-2-1-1 first">
<a href="https://www.labproservices.com/equipment/centrifugation/centrifuge-parts.html">
<span>Centrifuge Parts</span>
</a>
</li><li class="level2 nav-2-1-2">
<a href="https://www.labproservices.com/equipment/centrifugation/centrifuge-rotors.html">
<span>Centrifuge Rotors</span>
</a>
</li><li class="level2 nav-2-1-3 last">
<a href="https://www.labproservices.com/equipment/centrifugation/centrifuges.html">
<span>Centrifuges</span>
</a>
</li>
</ul>
</div>
</li><li class="level1 nav-2-2 parent">
<a href="https://www.labproservices.com/equipment/constant-temperature.html"><em>+</em>
<span>Constant Temperature</span>
</a>
<div class="sub-wrapper">
<ul class="level1">
<li class="level2 nav-2-2-4 first">
<a href="https://www.labproservices.com/equipment/constant-temperature/bath-accessories.html">
<span>Bath Accessories</span>
</a>
</li><li class="level2 nav-2-2-5">
<a href="https://www.labproservices.com/equipment/constant-temperature/baths.html">
<span>Baths</span>
</a>
</li><li class="level2 nav-2-2-6">
<a href="https://www.labproservices.com/equipment/constant-temperature/circulators.html">
<span>Circulators</span>
</a>
</li><li class="level2 nav-2-2-7">
<a href="https://www.labproservices.com/equipment/constant-temperature/co2-incubators.html">
<span>CO2 Incubators</span>
</a>
</li><li class="level2 nav-2-2-8">
<a href="https://www.labproservices.com/equipment/constant-temperature/humidity-test-chamber.html">
<span>Humidity Test Chamber</span>
</a>
</li><li class="level2 nav-2-2-9">
<a href="https://www.labproservices.com/equipment/constant-temperature/incubator-parts.html">
<span>Incubator Parts</span>
</a>
</li><li class="level2 nav-2-2-10">
<a href="https://www.labproservices.com/equipment/constant-temperature/incubators-general.html">
<span>Incubators, General</span>
</a>
</li><li class="level2 nav-2-2-11 last">
<a href="https://www.labproservices.com/equipment/constant-temperature/chillers.html">
<span>Chillers</span>
</a>
</li>
</ul>
</div>
</li><li class="level1 nav-2-3 parent">
<a href="https://www.labproservices.com/equipment/electrochemistry.html"><em>+</em>
<span>Electrochemistry</span>
</a>
<div class="sub-wrapper">
<ul class="level1">
<li class="level2 nav-2-3-12 first">
<a href="https://www.labproservices.com/equipment/electrochemistry/electrodes-sensors.html">
<span>Electrodes &amp; Sensors</span>
</a>
</li><li class="level2 nav-2-3-13 last">
<a href="https://www.labproservices.com/equipment/electrochemistry/electrochemistry-meters.html">
<span>Electrochemistry Meters</span>
</a>
</li>
</ul>
</div>
</li><li class="level1 nav-2-4 parent">
<a href="https://www.labproservices.com/equipment/heating.html"><em>+</em>
<span>Heating</span>
</a>
<div class="sub-wrapper">
<ul class="level1">
<li class="level2 nav-2-4-14 first">
<a href="https://www.labproservices.com/equipment/heating/autoclaves.html">
<span>Autoclaves</span>
</a>
</li><li class="level2 nav-2-4-15">
<a href="https://www.labproservices.com/equipment/heating/rotary-evaporators.html">
<span>Rotary Evaporators</span>
</a>
</li><li class="level2 nav-2-4-16">
<a href="https://www.labproservices.com/equipment/heating/heating-blocks.html">
<span>Heating Blocks</span>
</a>
</li><li class="level2 nav-2-4-17">
<a href="https://www.labproservices.com/equipment/heating/hot-plate-parts.html">
<span>Hot Plate Parts</span>
</a>
</li><li class="level2 nav-2-4-18">
<a href="https://www.labproservices.com/equipment/heating/hot-plates.html">
<span>Hot Plates</span>
</a>
</li><li class="level2 nav-2-4-19">
<a href="https://www.labproservices.com/equipment/heating/ovens.html">
<span>Ovens</span>
</a>
</li><li class="level2 nav-2-4-20 last">
<a href="https://www.labproservices.com/equipment/heating/rotary-evaporator-accessories.html">
<span>Rotary Evaporator Accessories</span>
</a>
</li>
</ul>
</div>
</li><li class="level1 nav-2-5 parent">
<a href="https://www.labproservices.com/equipment/instruments.html"><em>+</em>
<span>Instruments</span>
</a>
<div class="sub-wrapper">
<ul class="level1">
<li class="level2 nav-2-5-21 first">
<a href="https://www.labproservices.com/equipment/instruments/microscopes.html">
<span>Microscopes</span>
</a>
</li><li class="level2 nav-2-5-22 last">
<a href="https://www.labproservices.com/equipment/instruments/refractometers.html">
<span>Refractometers</span>
</a>
</li>
</ul>
</div>
</li><li class="level1 nav-2-6 parent">
<a href="https://www.labproservices.com/equipment/life-science.html"><em>+</em>
<span>Life Science</span>
</a>
<div class="sub-wrapper">
<ul class="level1">
<li class="level2 nav-2-6-23 first">
<a href="https://www.labproservices.com/equipment/life-science/electrophoresis.html">
<span>Electrophoresis</span>
</a>
</li><li class="level2 nav-2-6-24">
<a href="https://www.labproservices.com/equipment/life-science/freeze-dryers.html">
<span>Freeze Dryers</span>
</a>
</li><li class="level2 nav-2-6-25">
<a href="https://www.labproservices.com/equipment/life-science/freeze-dryer-parts.html">
<span>Freeze Dryer Parts</span>
</a>
</li><li class="level2 nav-2-6-26">
<a href="https://www.labproservices.com/equipment/life-science/pcr-equipment.html">
<span>PCR Equipment</span>
</a>
</li><li class="level2 nav-2-6-27 last">
<a href="https://www.labproservices.com/equipment/life-science/photo-documentation.html">
<span>Photo Documentation</span>
</a>
</li>
</ul>
</div>
</li><li class="level1 nav-2-7 parent">
<a href="https://www.labproservices.com/equipment/liquid-handling.html"><em>+</em>
<span>Liquid Handling</span>
</a>
<div class="sub-wrapper">
<ul class="level1">
<li class="level2 nav-2-7-28 first">
<a href="https://www.labproservices.com/equipment/liquid-handling/dispensers.html">
<span>Dispensers</span>
</a>
</li><li class="level2 nav-2-7-29 last">
<a href="https://www.labproservices.com/equipment/liquid-handling/pipettors.html">
<span>Pipettors</span>
</a>
</li>
</ul>
</div>
</li><li class="level1 nav-2-8 parent">
<a href="https://www.labproservices.com/equipment/mixing.html"><em>+</em>
<span>Mixing</span>
</a>
<div class="sub-wrapper">
<ul class="level1">
<li class="level2 nav-2-8-30 first">
<a href="https://www.labproservices.com/equipment/mixing/homogenizers-grinders.html">
<span>Homogenizers &amp; Grinders</span>
</a>
</li><li class="level2 nav-2-8-31">
<a href="https://www.labproservices.com/equipment/mixing/overhead-stirrers.html">
<span>Overhead Stirrers</span>
</a>
</li><li class="level2 nav-2-8-32">
<a href="https://www.labproservices.com/equipment/mixing/shakers.html">
<span>Shakers</span>
</a>
</li><li class="level2 nav-2-8-33">
<a href="https://www.labproservices.com/equipment/mixing/shaker-parts.html">
<span>Shaker Parts</span>
</a>
</li><li class="level2 nav-2-8-34">
<a href="https://www.labproservices.com/equipment/mixing/vortex-mixers.html">
<span>Vortex Mixers</span>
</a>
</li><li class="level2 nav-2-8-35 last">
<a href="https://www.labproservices.com/equipment/mixing/vortex-parts.html">
<span>Vortex Parts</span>
</a>
</li>
</ul>
</div>
</li><li class="level1 nav-2-9 parent">
<a href="https://www.labproservices.com/equipment/pumps.html"><em>+</em>
<span>Pumps</span>
</a>
<div class="sub-wrapper">
<ul class="level1">
<li class="level2 nav-2-9-36 first">
<a href="https://www.labproservices.com/equipment/pumps/peristaltic.html">
<span>Peristaltic Pumps</span>
</a>
</li><li class="level2 nav-2-9-37 last">
<a href="https://www.labproservices.com/equipment/pumps/vacuum.html">
<span>Vacuum Pumps</span>
</a>
</li>
</ul>
</div>
</li><li class="level1 nav-2-10 parent">
<a href="https://www.labproservices.com/equipment/refrigeration-and-freezers.html"><em>+</em>
<span>Refrigeration</span>
</a>
<div class="sub-wrapper">
<ul class="level1">
<li class="level2 nav-2-10-38 first">
<a href="https://www.labproservices.com/equipment/refrigeration-and-freezers/refrigerators-freezers.html">
<span>Refrigerators &amp; Freezers</span>
</a>
</li><li class="level2 nav-2-10-39">
<a href="https://www.labproservices.com/equipment/refrigeration-and-freezers/refrigeration-parts.html">
<span>Refrigeration Parts</span>
</a>
</li><li class="level2 nav-2-10-40 last">
<a href="https://www.labproservices.com/equipment/refrigeration-and-freezers/ultra-low-freezers.html">
<span>Ultra Low Freezers</span>
</a>
</li>
</ul>
</div>
</li><li class="level1 nav-2-11 parent">
<a href="https://www.labproservices.com/equipment/water-systems.html"><em>+</em>
<span>Water Systems</span>
</a>
<div class="sub-wrapper">
<ul class="level1">
<li class="level2 nav-2-11-41 first">
<a href="https://www.labproservices.com/equipment/water-systems/water-system-cartridges.html">
<span>Water System Cartridges</span>
</a>
</li><li class="level2 nav-2-11-42">
<a href="https://www.labproservices.com/equipment/water-systems/water-system-parts.html">
<span>Water System Parts</span>
</a>
</li><li class="level2 nav-2-11-43 last">
<a href="https://www.labproservices.com/equipment/water-systems/water-systems.html">
<span>Water Systems</span>
</a>
</li>
</ul>
</div>
</li><li class="level1 nav-2-12 last parent">
<a href="https://www.labproservices.com/equipment/weighing.html"><em>+</em>
<span>Weighing</span>
</a>
<div class="sub-wrapper">
<ul class="level1">
<li class="level2 nav-2-12-44 first">
<a href="https://www.labproservices.com/equipment/weighing/balances-and-scales.html">
<span>Balances and Scales</span>
</a>
</li><li class="level2 nav-2-12-45">
<a href="https://www.labproservices.com/equipment/weighing/moisture-analyzers.html">
<span>Moisture Analyzers</span>
</a>
</li><li class="level2 nav-2-12-46 last">
<a href="https://www.labproservices.com/equipment/weighing/weighing-parts.html">
<span>Weighing Parts</span>
</a>
</li>
</ul>
</div>
</li></ol></li>
</ul>
</div>
</li><li class="level0 level-top parent short-width"><a class="level-top" href="/furniture.html"><em>+</em> <span>Furniture</span> </a>
<div class="sub-wrapper" style="left: -10000px;">
<ul class="level0">
<li><ol>
<li class="level1 nav-1-1 first"><a href="http://chairs.labproservices.com/"> <span>Chairs</span> </a></li>
<li class="level1 nav-1-2"><a href="/furniture/safety-cabinets.html"> <span>Safety Cabinets</span> </a></li>
</ol></li>
</ul>
</div>
</li>
<li class="level0 level-top parent short-width"><a class="level-top" href="/Blog/"><em>+</em> <span>BLOG</span> </a>
<div class="sub-wrapper" style="left: -10000px;">
<ul class="level0 short-width">
<li><ol>
<li class="level1 nav-1-2 short-width"><a href="/Blog/The-Four-Purchasing-Paradigms/">What is Your Strategy to Reduce Lab Supply Costs?</a></li>
<li class="level1 nav-1-3 short-width"><a href="/Blog/Reducing-the-Cost-of-Procurement-for-the-Lab/">Streamlining the Procure to Pay Cycle</a></li>
<li class="level1 nav-1-4 short-width"><a href="/Blog/brand-name-lab-items-worth-the-price/">Brand Name Lab Items: Worth the Price?</a></li>
<li class="level1 nav-1-5 short-width"><a href="/Blog/Pain_Points/">Top 5 Pain Points</a></li>
<li class="level1 nav-1-6 short-width"><a href="/Blog/Procurement-as-a-Profit-Center/">Procurement as a Profit Center</a></li>
<li class="level1 nav-1-7 short-width"><a href="/Blog/a-view-from-the-other-side-a-preview/">A View From the Other Side</a></li>
<li class="level1 nav-1-8 short-width"><a href="/Blog/"> <b style="color: red;">View Full Blog</b></a></li>
</ol></li>
</ul>
</div>
</li>
<li class="level0 level-top parent"><a class="level-top" href="/about-us/"><em>+</em> <span>Company</span> </a>
<div class="sub-wrapper" style="left: -10000px;">
<ul class="level0">
<li><ol>
<li class="level1 nav-1-1 first parent">
<h4 style="padding: 0  10px 15px;"><a title="about-lps" href="/about-lps/">SERVICES</a></h4>
</li>
<li class="level1 nav-1-2"><a href="/consulting/">Services Overview</a></li>
<li class="level1 nav-1-3"><a href="/Lab-Supply-Contract-Management/">Contract Management</a></li>
<li class="level1 nav-1-4"><a href="/lab-supply-vendor-management/">Vendor Management<br></a></li>
<li class="level1 nav-1-5"><a href="/logistics-and-supply-chain-management">Logistics &amp; Supply Chain</a></li>
<li class="level1 nav-1-6"><a href="/international-services/">International Services</a></li>
<li class="level1 nav-1-7"><a href="/procurement-services/paperless-procurement/">Paperless Procurement</a></li>
<li class="level1 nav-1-8"><a href="/Cost-Savings-Metrics">Cost Saving Metrics</a></li>
<li class="level1 nav-1-9"><a href="/lab-procurement-portal/">Lab Procurement Portal</a></li>
</ol></li>
<li><ol>
<li class="level1 nav-1-8 parent">
<h4 style="padding: 0  10px 15px;"><a title="industries" href="/industries">INDUSTRIES</a></h4>
</li>
<li class="level1 nav-2-9"><a href="/industries/breweries/"><span>Breweries</span></a></li>
<li class="level1 nav-2-9"><a href="/industries/clinical/"><span>Clinical</span></a></li>
<li class="level1 nav-2-10"><a href="/industries/education/"> <span>Education</span></a></li>
<li class="level1 nav-2-10"><a href="/industries/environmental/"><span>Environmental</span></a></li>
<li class="level1 nav-2-11"><span><a href="/industries/life-science/">Life Science</a></span></li>
<li class="level1 nav-2-12"><span><a href="/industries/manufacturing/">Manufacturing</a></span></li>
</ol></li>
<li><ol>
<li class="level1 nav-1-8 parent">
<h4 style="padding: 0  10px 15px;"><a title="innovations" href="/innovations">INNOVATIONS</a></h4>
</li>
<li class="level1 nav-1-9"><a href="/innovations/big-tip-box/"><span>Big Tip Box</span></a></li>
<li class="level1 nav-1-10"><a href="/innovations/labstrong/"> <span>LabStrong</span></a></li>
<li class="level1 nav-1-11"><a href="/SnapIt-Safe-Ampule-Opener/"><span>SnapIt</span></a></li>
<li class="level1 nav-1-12"><span><a href="/innovations/vivest/">ViveST</a></span></li>
<li class="level1 nav-1-13"><span><a href="/supplies/liquid-handling/pipet-tips/l/lps-innovations.html">LPS Pipet Tips</a></span></li>
<li class="level1 nav-1-14"><span><a href="https://www.pipettipfinder.com">PipetTipFinder.com</a></span></li>
</ol></li>
<li class="last"><ol>
<li class="level1 nav-1-8 parent">
<h4 style="padding: 0  10px 15px;"><a title="contact-us" href="/contact-us/">CONTACTS</a></h4>
</li>
<li class="level1 nav-1-14"><a href="/contact-us/"> <span>Address &amp; Phone</span> </a></li>
<li class="level1 nav-1-13 first"><a href="/about-lps/"><span>About Us</span> </a></li>
<li class="level1 nav-1-15"><a href="/our-story/">Our Story</a></li>
<li class="level1 nav-1-16 first"><a href="/faq/"><span>FAQ</span> </a></li>
<li class="level1 nav-1-16 first"><a href="/terms-and-conditions/"><span>Terms &amp; Conditions</span> </a></li>
<li class="level1 nav-1-18"><a href="https://www.facebook.com/LabProServices/" target="lab1"><img style="max-width: 32px; border: 0px; float: left; margin-top: 7px;" alt="" src="https://www.labproservices.com/media/facebook-icon.png"></a><a href="https://www.linkedin.com/company/3157037/" target="lab2"><img style="max-width: 32px; border: 0px; float: left; margin-top: 7px;" alt="" src="https://www.labproservices.com/media/linkedin-icon.png"></a></li>
</ol></li>
</ul>
</div>
</li>
</ul>
</div>
<!-- navigation EOF -->                        <!-- NAVIGATION EOF -->
<div id="topsearchdiv">
<form id="search_mini_form" action="https://www.labproservices.com/catalogsearch/result/" method="get" siq_id="autopick_1472">
    <div class="form-search searchsuite-form-search">
        <input class="reset-button" value="x" type="button" style="display: none; left: 112px;"><input id="search" type="text" tabindex="1" name="q" value="" class="searchsuite-input searchsuite-default-text" maxlength="128" style="width:340px;" autocomplete="off">

                <input type="submit" tabindex="3" title="GO" value="GO" class="searchsuite-submit">
        <div id="search_autocomplete" class="search-autocomplete" style="display: none;"></div>
        <script type="text/javascript">
            //<![CDATA[
            var searchForm = new Varien.searchForm('search_mini_form', 'search', '');
            searchForm.initAutocomplete('https://www.labproservices.com/catalogsearch/ajax/suggest/', 'search_autocomplete');
            jQuery(document).ready(function() {
                jQuery('#search').searchSuite({text: "SEARCH CATALOG",
                    value: "",
                    attributes:0,
                    categories:0});
            });
            //]]>
        </script>
    </div>
</form></div>

                        <div class="top-dropdowns clearfix">
                            <!-- cart BOF -->
<div class="cart-top-title"><a href="https://www.labproservices.com/checkout/cart/" class="clearfix"><span class="icon"></span>Bag</a></div>
<div class="cart-top-container">
    <div class="cart-top">
        <a class="summary" href="https://www.labproservices.com/checkout/cart/"></a>
        <span>CART (0)</span>
    </div>
    <div class="details">
        <div class="details-border"></div>
	                            <p class="a-center">You have no items in your shopping cart.</p>
            </div>
</div>
<!-- cart EOF -->                            <div class="compare-top-title"><a href="#" class="clearfix" onclick="popWin('https://www.labproservices.com/catalog/product_compare/index/uenc/aHR0cHM6Ly93d3cubGFicHJvc2VydmljZXMuY29tLw,,/','compare','top:0,left:0,width=820,height=600,resizable=yes,scrollbars=yes')"><span class="icon"></span>Compare</a></div>
<div class="compare-top-container">
    <div class="compare-top">
        <a class="summary" href="#" onclick="popWin('https://www.labproservices.com/catalog/product_compare/index/uenc/aHR0cHM6Ly93d3cubGFicHJvc2VydmljZXMuY29tLw,,/','compare','top:0,left:0,width=820,height=600,resizable=yes,scrollbars=yes')"></a>
    </div>
    <div class="details">
        <div class="details-border"></div>
            <p class="empty">You have no items to compare.</p>
        </div>
</div>
                        </div>

<div style="margin:0 auto;text-align:center;">
<a href="https://www.labproservices.com/Blog/covid-19-related-products/" style="font-weight:700;font-size:17px;color:#5488bf;text-align:center;">COVID-19 Products Available for Immediate Shipment!</a>
</div>

                    </div>

                </div>


	            </header>


    </div>

</div>
`
